<template>
  <div class="vcr-page__section">
    <template v-if="title">
      <h2 class="vcr-page__header">{{ title }}</h2>
      <hr />
    </template>

    <table>
      <thead>
        <tr>
          <th class="vcr-page__table-first-column">
            {{ i18n.t('/Vcr/Accessory Tables/Shared/Part Label') }}
          </th>
          <th>{{ i18n.t('/Vcr/Accessory Tables/Shared/Code Label') }}</th>
          <th>{{ i18n.t('/Vcr/Accessory Tables/Shared/Buy Label') }}</th>
          <th>{{ i18n.t('/Vcr/Accessory Tables/Shared/Sell Label') }}</th>
          <th>{{ i18n.t('/Vcr/Accessory Tables/Shared/Margin Label') }}</th>
          <th>{{ i18n.t('/Vcr/Accessory Tables/Shared/Percentage Label') }}</th>
        </tr>
      </thead>

      <tbody v-if="items">
        <tr v-for="(item, index) in items" :key="index">
          <td>{{ item.Name }}</td>
          <td>{{ item[codeFieldName] }}</td>
          <td>{{ i18n.n(item.Price.PurchaseExcl, 'currency') }}</td>
          <td>{{ i18n.n(item.Price.Excl, 'currency') }}</td>
          <td>{{ CurrencyHelper.margin(item.Price.MarginExcl) }}</td>
          <td>{{ CurrencyHelper.marginPercentage(item.Price.MarginPercentage) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import CurrencyHelper from '@/helpers/currencyHelper'

export default {
  props: {
    title: { type: String, default: '' },
    codeFieldName: { type: String, default: 'ID' },
    items: { type: Array, default: () => [] },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      CurrencyHelper: CurrencyHelper,
    }
  },
}
</script>
